import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { CheckingAccountService } from '@core/services/checking-account/checking-account.service';
@Injectable()
export class SummaryGuard implements CanActivate {
  constructor(
    private readonly orderAccessService: CheckingAccountService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Si hay un orderId en los query params, permitir el acceso (viene de una notificación)
    const orderId = route.queryParams['orderId'];
    if (orderId) {
      return true; // Permitir acceso cuando viene de una notificación
    }

    // Si no hay orderId, verificar el acceso normal
    if (this.orderAccessService.isAccessPermitted()) {
      return true; // Permite el acceso a la URL '/main/checkout'
    } else {
      this.router.navigate(['/main/inicio']); // Redirige a la página de inicio si no se permite el acceso
      return false;
    }
  }
}
